import React from 'react';
import useGroupLabels from 'hooks/useGroupLabels';
import { formatGroupCell } from 'utils/groupLabel';
import styles from './StartListsEditor.module.css';

// Format milliseconds to proper time format
const formatTime = (milliseconds) => {
  if (!milliseconds || milliseconds === 'N/A') return 'N/A';
  
  const totalSeconds = milliseconds / 1000;
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  
  if (minutes > 0) {
    return `${minutes}:${seconds.toFixed(2).padStart(5, '0')}`;
  } else {
    return seconds.toFixed(2);
  }
};

const HeatsSection = ({
  heats,
  selectedLanes,
  selectedLaneAthlete,
  onLaneClick,
  onRemoveAthlete,
  onClearHeat,
  onRemoveHeat,
  isMultilaneEvent = true // NEW PROP
}) => {
  // The badge beside an athlete reads "11", or "Y6" for a club that groups by year level.
  const { groupingBasis } = useGroupLabels();

  return (
    <div className={styles.heatsSection}>
      <div className={styles.heatsContainer}>
        {heats.map((heat, heatIndex) => (
          <div
            key={heat.id}
            className={styles.heatCard}
          >
            <div className={styles.heatHeader}>
              <span>
                {/* UPDATED: Show "Heat" or "Group" based on event type */}
                {isMultilaneEvent ? 'Heat' : 'Group'} {heat.id} (
                {Object.values(heat.lanes).filter((a) => a).length}
                {/* UPDATED: Only show max count for multilane */}
                {isMultilaneEvent && `/${selectedLanes.length}`})
              </span>
              <div className={styles.heatActions}>
                <button
                  onClick={() => onClearHeat(heatIndex)}
                  className={styles.heatActionButton}
                >
                  Clear
                </button>
                {heatIndex > 0 && (
                  <button
                    onClick={() => onRemoveHeat(heatIndex)}
                    className={styles.heatActionButton}
                  >
                    ✕
                  </button>
                )}
              </div>
            </div>

            <div className={`${styles.heatContent} ${!isMultilaneEvent ? styles.scrollableContent : ''}`}>
              {selectedLanes.map((lane) => {
                const isSelected =
                  selectedLaneAthlete?.heatIndex === heatIndex &&
                  selectedLaneAthlete?.lane === lane;
                const athlete = heat.lanes[lane];
                
                return (
                  <div
                    key={lane}
                    onClick={() => onLaneClick(heatIndex, lane)}
                    className={`${styles.laneCard} ${
                      isSelected ? styles.laneCardSelected : 
                      athlete ? styles.laneCardOccupied : ''
                    }`}
                  >
                    {/* UPDATED: Show "Lane X" or just "X" based on event type */}
                    <div className={styles.laneNumber}>
                      {isMultilaneEvent ? `Lane ${lane}` : lane}
                    </div>
                    {athlete ? (
                      <>
                        <div className={styles.athleteCardRow1}>
                          <span className={styles.athleteName}>
                            {athlete.firstName} {athlete.lastName}
                          </span>
                          <span className={styles.athleteId}>{athlete.athleteNumber}</span>
                        </div>
                        <div className={styles.athleteCardRow2}>
                          <span className={styles.badge}>{formatGroupCell(groupingBasis, athlete.age)}</span>
                          <span className={styles.badge}>{athlete.gender}</span>
                          <span className={styles.sbLabel}>SB:</span>
                          <span className={styles.sbValue}>{formatTime(athlete.seasonBest)}</span>
                        </div>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onRemoveAthlete(heatIndex, lane);
                          }}
                          className={styles.removeAthleteButton}
                        >
                          ✕
                        </button>
                      </>
                    ) : (
                      <div className={styles.emptyLane}>
                        Empty
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HeatsSection;